import { useCallback, useEffect, useState } from "react";
import Header from "./components/Header";
import StairTransition from "./components/ui/StairTransition";
import Cursor from "./components/ui/Cursor";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Personal from "./pages/Personal";

const PAGES = { "/": Home, "/contact": Contact, "/personal": Personal };

// Hash routing keeps static hosting simple (no rewrites needed).
const currentRoute = () => {
  const path = window.location.hash.replace(/^#/, "") || "/";
  return PAGES[path] ? path : "/";
};

const App = () => {
  const [route, setRoute] = useState(currentRoute);

  useEffect(() => {
    const onHash = () => setRoute(currentRoute());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  const navigate = useCallback((path) => {
    window.location.hash = path;
    window.scrollTo({ top: 0 });
  }, []);

  const Page = PAGES[route];

  return (
    <div className="min-h-screen">
      <Cursor />
      <Header route={route} navigate={navigate} />
      <StairTransition routeKey={route} />
      <Page key={route} navigate={navigate} />
    </div>
  );
};

export default App;
